export const { VUE_APP_IS_API_CANAL_AVAILABLE } = process.env
export const { VUE_APP_BACKEND_URL } = process.env
export const { VUE_APP_NAME } = process.env
export const { VUE_APP_DEFAULT_PWD } = process.env
export const { VUE_APP_PAYMENT_URL } = process.env
export const MAX_LOGIN_ATTEMPTS = process.env.VUE_APP_MAX_LOGIN_ATTEMPTS
export const ACCOUNT_BLOCKED = -1
export const ACCOUNT_PENDING = 1 // variable permettant de savoir si l'utilisateur est à sa première connexion
export const ACCOUNT_ACTIVE = 1
